import Flickity from 'flickity';
import imagesloaded from 'flickity-imagesloaded'; // eslint-disable-line no-unused-vars

export default () => {
    const gallery = document.querySelectorAll('.image-carousel .image-carousel__items');

    const initialize = (el) => {
        if (el.children.length > 1) {
            new Flickity(el, {
                cellAlign: 'left',
                contain: true,
                prevNextButtons: false,
                pageDots: true,
                wrapAround: false,
                adaptiveHeight: false,
                imagesLoaded: true,
                resize: true,
            });
        }
    };

    for (const el of gallery) {
        initialize(el);

        // Hide dots if we don't have anything offscreen
        const lastImage = el.querySelector('.image-carousel__item:last-child');
        const lastImageBox = lastImage.getBoundingClientRect();
        const galleryBox = el.getBoundingClientRect();

        if (lastImageBox.right < galleryBox.right && el.querySelector('.flickity-page-dots')) {
            el.querySelector('.flickity-page-dots').style.display = 'none';
        }
    }
};
